(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fnt-about-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.fntaReady) return;
      root.dataset.fntaReady = '1';
      var track = root.querySelector('[data-dif-track]');
      var dots = root.querySelectorAll('[data-dif-dots] .fnta-dot');
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function () {
        var card = track.firstElementChild;
        if (!card) return;
        var step = card.getBoundingClientRect().width + 12;
        var idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / step));
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      }, { passive: true });
    }
    document.querySelectorAll('.fnta').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('.fnta'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slug(text, i) {
      var base = String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      return (base || 'seccion') + '-' + i;
    }

    function heads(content) {
      var h2 = Array.prototype.slice.call(content.querySelectorAll('h2'));
      var h3 = Array.prototype.slice.call(content.querySelectorAll('h3'));
      return h2.length >= 2 ? h2 : (h3.length >= 2 ? h3 : []);
    }

    function buildToc(content, list) {
      var box = document.querySelector('[data-toc]');
      var body = document.querySelector('[data-body]');
      var hs = heads(content);
      if (!hs.length || !box || !body) return [];

      hs.forEach(function (h, i) {
        h.classList.add('fntn-h');
        if (!h.id) h.id = slug(h.textContent, i + 1);
        var a = document.createElement('a');
        a.className = 'fntn-toc__link';
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        list.appendChild(a);
      });

      box.hidden = false;
      body.classList.add('has-toc');

      if ('IntersectionObserver' in window) {
        var links = Array.prototype.slice.call(list.querySelectorAll('.fntn-toc__link'));
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            links.forEach(function (l) {
              l.classList.toggle('is-on', l.getAttribute('href') === '#' + entry.target.id);
            });
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        hs.forEach(function (h) { obs.observe(h); });
      }
      return hs;
    }

    function placeRec(content, hs) {
      var rec = document.querySelector('[data-rec]');
      if (!rec || !content) return;
      var anchor = null;
      if (hs && hs.length >= 4) {
        anchor = hs[hs.length - 2];
      } else if (hs && hs.length >= 2) {
        anchor = hs[hs.length - 1];
      } else {
        var ps = content.querySelectorAll(':scope > p');
        if (ps.length >= 4) anchor = ps[Math.max(0, Math.round(ps.length * 0.75) - 1)];
      }
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(rec, anchor);
        rec.classList.add('is-inline');
      }
    }

    // Tarjeta horizontal: el panel de opciones (computadora) va dentro del cuerpo,
    // justo antes del botón, para que no tape el botón de agregar.
    function recPanel() {
      var card = document.querySelector('[data-rec] [data-fnt-pc]');
      if (!card) return;
      var panel = card.querySelector('[data-fnt-pc-panel]');
      var btn = card.querySelector('[data-fnt-pc-btn]');
      if (panel && btn && btn.parentNode) btn.parentNode.insertBefore(panel, btn);
    }

    function progress() {
      var bar = document.querySelector('[data-progress]');
      var content = document.querySelector('[data-article-content]');
      if (!bar || !content) return;
      function tick() {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        var done = total > 0 ? (-rect.top) / total : 0;
        bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, done)) + ')';
      }
      tick();
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick);
    }

    function share() {
      var btn = document.querySelector('[data-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy');
        var label = btn.querySelector('[data-copy-label]') || btn;
        var done = function () {
          var old = label.textContent;
          label.textContent = 'Enlace copiado';
          setTimeout(function () { label.textContent = old; }, 1800);
        };
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        }
      });
    }

    function boot() {
      var content = document.querySelector('[data-article-content]');
      var list = document.querySelector('[data-toc-list]');
      var hs = content && list ? buildToc(content, list) : [];
      if (content) placeRec(content, hs);
      recPanel();
      progress();
      share();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-collection-view')) return;

    var SIZE_NAMES = ['gramaje', 'presentación', 'presentacion', 'tamaño', 'tamano'];
    var SORT_LABELS = { best: 'Más vendidos', asc: 'Precio: menor a mayor', desc: 'Precio: mayor a menor', az: 'Nombre: A–Z' };

    function norm(value) {
      return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function grams(value) {
      var v = norm(value);
      var sachets = v.match(/(\d+)\s*sobres?.*?(\d+)\s*g/);
      if (sachets) return Number(sachets[1]) * Number(sachets[2]);
      var kg = v.match(/(\d+(?:\.\d+)?)\s*kg/);
      if (kg) return Number(kg[1]) * 1000;
      var g = v.match(/(\d+(?:\.\d+)?)\s*g/);
      return g ? Number(g[1]) : NaN;
    }
    function sizeLabel(raw) {
      var v = norm(raw);
      if (/sobre/.test(v)) return 'Sobres';
      if (/kg/.test(v)) return raw;
      var g = v.match(/^(\d+(?:\.\d+)?)\s*g\.?$/);
      if (!g) return raw;
      var n = Number(g[1]);
      if (n >= 1000) return String(Math.round(n / 10) / 100).replace(/\.0+$/, '') + ' kg';
      return n + ' g';
    }
    function groupName(name) {
      var n = norm(name);
      if (SIZE_NAMES.indexOf(n) > -1) return 'Presentación';
      if (n.indexOf('sabor') === 0) return 'Sabor';
      if (n === 'title' || n === 'título' || n === 'titulo') return null;
      return name;
    }
    function money(cents) {
      return '$' + Math.round(cents / 100).toLocaleString('es-MX');
    }

    var ICON_X = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var ICON_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';

    class FntCollectionView extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;
        this.pageSize = Number(this.dataset.pageSize) || 12;
        this.promo = this.querySelector('[data-promo]');
        this.labels = {};
        this.items = Array.from(this.grid.querySelectorAll('.fntc-item')).map(function (el) {
          var raw = {};
          try { raw = JSON.parse(el.dataset.filters || '{}'); } catch (e) {}
          var groups = {};
          Object.keys(raw).forEach(function (name) {
            var g = groupName(name);
            if (!g) return;
            groups[g] = groups[g] || { names: [], values: [] };
            groups[g].names.push(norm(name));
            (raw[name] || []).forEach(function (v) {
              var k = norm(v);
              if (norm(v) === 'default title') return;
              self.labels[g] = self.labels[g] || new Map();
              if (!self.labels[g].has(k)) self.labels[g].set(k, v);
              if (groups[g].values.indexOf(k) === -1) groups[g].values.push(k);
            });
          });
          return {
            el: el,
            groups: groups,
            price: Number(el.dataset.price) || 0,
            avail: el.dataset.avail !== 'false',
            title: norm(el.dataset.title) + ' ' + String(grams(el.dataset.size) || 0).padStart(6, '0'),
            rank: Number(el.dataset.rank) || 0
          };
        });

        this.state = { sel: {}, sort: 'best', min: null, max: null, stock: false, limit: this.pageSize };
        this.buildGroups();
        this.bind();
        this.apply();
        this._onResize = function () { self.placePromo(); };
        window.addEventListener('resize', this._onResize);
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }

      // ---------- construir grupos de filtro ----------
      buildGroups() {
        var self = this;
        var box = this.querySelector('[data-groups]');
        if (!box) return;
        var html = '';
        Object.keys(this.labels).forEach(function (g) {
          var values = Array.from(self.labels[g].entries());
          if (values.length < 2) return;
          self.state.sel[g] = [];
          if (g === 'Presentación') {
            values.sort(function (a, b) {
              var ga = grams(a[1]), gb = grams(b[1]);
              if (isNaN(ga)) return 1;
              if (isNaN(gb)) return -1;
              return ga - gb;
            });
            html += '<section class="fntc-group"><h3 class="fntc-group__title">Presentación</h3><div class="fntc-pills">';
            values.forEach(function (e) {
              html += '<button type="button" class="fntc-pill" data-g="' + esc(g) + '" data-v="' + esc(e[0]) + '" aria-pressed="false">' + esc(sizeLabel(e[1])) + '</button>';
            });
            html += '</div></section>';
          } else {
            html += '<section class="fntc-group"><h3 class="fntc-group__title">' + esc(g) + '</h3><div class="fntc-checks">';
            values.forEach(function (e) {
              html += '<button type="button" class="fntc-check" data-g="' + esc(g) + '" data-v="' + esc(e[0]) + '" aria-pressed="false"><span class="fntc-check__box">' + ICON_CHECK + '</span><span class="fntc-check__label">' + esc(e[1]) + '</span><span class="fntc-check__n" data-n></span></button>';
            });
            html += '</div></section>';
          }
        });
        box.innerHTML = html;
      }

      // ---------- eventos ----------
      bind() {
        var self = this;
        this.addEventListener('click', function (e) {
          var t = e.target;
          var opt = t.closest('[data-g]');
          if (opt && !opt.disabled) {
            var list = self.state.sel[opt.dataset.g] || [];
            var i = list.indexOf(opt.dataset.v);
            if (i > -1) list.splice(i, 1); else list.push(opt.dataset.v);
            self.state.sel[opt.dataset.g] = list;
            self.resetLimit();
            return self.apply();
          }
          var chip = t.closest('[data-chip]');
          if (chip) {
            var k = chip.dataset.chip;
            if (k === 'price') { self.state.min = null; self.state.max = null; self.syncPriceInputs(); }
            else if (k === 'stock') { self.state.stock = false; }
            else {
              var parts = k.split('::');
              var l = self.state.sel[parts[0]] || [];
              var j = l.indexOf(parts[1]);
              if (j > -1) l.splice(j, 1);
            }
            self.resetLimit();
            return self.apply();
          }
          if (t.closest('[data-clear]')) return self.clearAll();
          var s = t.closest('[data-sort]');
          if (s) {
            self.state.sort = s.dataset.sort;
            self.toggleSortMenu(false);
            self.resetLimit();
            return self.apply();
          }
          if (t.closest('[data-sort-toggle]')) {
            var menu = self.querySelector('[data-sort-menu]');
            return self.toggleSortMenu(menu.hidden);
          }
          if (t.closest('[data-stock]')) {
            self.state.stock = !self.state.stock;
            self.resetLimit();
            return self.apply();
          }
          if (t.closest('[data-toggle-panel]')) {
            var hidden = self.classList.toggle('is-panel-hidden');
            self.querySelector('[data-toggle-label]').textContent = hidden ? 'Mostrar filtros' : 'Ocultar filtros';
            return self.placePromo();
          }
          if (t.closest('[data-open-sheet]')) return self.sheet(true);
          if (t.closest('[data-close-sheet]') || t.closest('[data-backdrop]')) return self.sheet(false);
          if (t.closest('[data-load-more]')) {
            self.state.limit += self.pageSize;
            return self.apply();
          }
        });

        document.addEventListener('click', function (e) {
          if (!self.contains(e.target) || !e.target.closest('.fntc-sort')) self.toggleSortMenu(false);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { self.toggleSortMenu(false); self.sheet(false); }
        });

        var timer;
        ['[data-price-min]', '[data-price-max]'].forEach(function (sel) {
          var input = self.querySelector(sel);
          if (!input) return;
          input.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              var a = self.querySelector('[data-price-min]').value;
              var b = self.querySelector('[data-price-max]').value;
              self.state.min = a === '' ? null : Number(a) * 100;
              self.state.max = b === '' ? null : Number(b) * 100;
              self.resetLimit();
              self.apply();
            }, 350);
          });
        });

        // Placeholder de precio con el rango real
        var prices = this.items.map(function (it) { return it.price; }).filter(Boolean);
        if (prices.length) {
          var mi = this.querySelector('[data-price-min]');
          var ma = this.querySelector('[data-price-max]');
          if (mi) mi.placeholder = Math.floor(Math.min.apply(null, prices) / 100);
          if (ma) ma.placeholder = Math.ceil(Math.max.apply(null, prices) / 100);
        }
      }

      toggleSortMenu(open) {
        var menu = this.querySelector('[data-sort-menu]');
        var btn = this.querySelector('[data-sort-toggle]');
        if (!menu || !btn) return;
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      sheet(open) {
        var panel = this.querySelector('[data-panel]');
        var bd = this.querySelector('[data-backdrop]');
        if (!panel) return;
        if (open && window.matchMedia('(min-width: 990px)').matches) return;
        this.classList.toggle('is-sheet-open', open);
        if (bd) bd.hidden = !open;
        document.documentElement.classList.toggle('fnt-sheet-lock', open);
        if (open) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          var close = panel.querySelector('[data-close-sheet]');
          if (close) close.focus();
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
        }
      }

      syncPriceInputs() {
        var a = this.querySelector('[data-price-min]');
        var b = this.querySelector('[data-price-max]');
        if (a) a.value = this.state.min == null ? '' : this.state.min / 100;
        if (b) b.value = this.state.max == null ? '' : this.state.max / 100;
      }

      resetLimit() {
        this.state.limit = this.pageSize;
      }

      clearAll() {
        var sel = this.state.sel;
        Object.keys(sel).forEach(function (g) { sel[g] = []; });
        this.state.min = null;
        this.state.max = null;
        this.state.stock = false;
        this.syncPriceInputs();
        this.resetLimit();
        this.apply();
      }

      // ---------- lógica de filtrado ----------
      passes(it, skipGroup) {
        var s = this.state;
        var ok = Object.keys(s.sel).every(function (g) {
          if (g === skipGroup) return true;
          var list = s.sel[g];
          if (!list.length) return true;
          if (!it.groups[g]) return false;
          return list.some(function (v) { return it.groups[g].values.indexOf(v) > -1; });
        });
        if (!ok) return false;
        if (s.min != null && it.price < s.min) return false;
        if (s.max != null && it.price > s.max) return false;
        if (s.stock && !it.avail) return false;
        return true;
      }

      apply() {
        var self = this;
        var s = this.state;

        // Orden
        var sorted = this.items.slice();
        if (s.sort === 'asc') sorted.sort(function (a, b) { return a.price - b.price || a.rank - b.rank; });
        else if (s.sort === 'desc') sorted.sort(function (a, b) { return b.price - a.price || a.rank - b.rank; });
        else if (s.sort === 'az') sorted.sort(function (a, b) { return a.title.localeCompare(b.title, 'es'); });
        else sorted.sort(function (a, b) { return a.rank - b.rank; });

        var matches = sorted.filter(function (it) { return self.passes(it); });
        var total = matches.length;
        var shown = Math.min(total, s.limit);
        var frag = document.createDocumentFragment();
        sorted.forEach(function (it) { frag.appendChild(it.el); });
        this.grid.insertBefore(frag, this.grid.firstChild);
        sorted.forEach(function (it) { it.el.hidden = true; });
        matches.slice(0, shown).forEach(function (it) { it.el.hidden = false; });
        this.lastShown = shown ? matches[shown - 1].el : null;
        this.shownCount = shown;

        // Conteos facetados y estado de botones
        this.querySelectorAll('[data-g]').forEach(function (btn) {
          var g = btn.dataset.g, v = btn.dataset.v;
          var on = (s.sel[g] || []).indexOf(v) > -1;
          var n = self.items.filter(function (it) {
            return self.passes(it, g) && it.groups[g] && it.groups[g].values.indexOf(v) > -1;
          }).length;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.classList.toggle('is-on', on);
          btn.disabled = n === 0 && !on;
          var nEl = btn.querySelector('[data-n]');
          if (nEl) nEl.textContent = n;
        });

        // Orden: etiquetas y radios
        this.querySelectorAll('[data-sort-label], [data-sort-label-m]').forEach(function (el) { el.textContent = SORT_LABELS[s.sort]; });
        this.querySelectorAll('[data-sort]').forEach(function (b) {
          b.classList.toggle('is-on', b.dataset.sort === s.sort);
          b.setAttribute('aria-selected', b.dataset.sort === s.sort ? 'true' : 'false');
        });
        var sw = this.querySelector('[data-stock]');
        if (sw) { sw.classList.toggle('is-on', s.stock); sw.setAttribute('aria-pressed', s.stock ? 'true' : 'false'); }

        // Filtros aplicados
        var chips = [];
        Object.keys(s.sel).forEach(function (g) {
          s.sel[g].forEach(function (v) {
            var label = (self.labels[g] && self.labels[g].get(v)) || v;
            if (g === 'Presentación') label = sizeLabel(label);
            chips.push({ key: g + '::' + v, label: label });
          });
        });
        if (s.min != null || s.max != null) {
          var pl = (s.min != null ? money(s.min) : '$0') + ' – ' + (s.max != null ? money(s.max) : 'máx.');
          chips.push({ key: 'price', label: pl });
        }
        if (s.stock) chips.push({ key: 'stock', label: 'Sin agotados' });
        var chipBox = this.querySelector('[data-chips]');
        if (chipBox) {
          var h = '';
          chips.forEach(function (c) {
            h += '<button type="button" class="fntc-chip" data-chip="' + esc(c.key) + '" aria-label="Quitar filtro ' + esc(c.label) + '">' + esc(c.label) + ' ' + ICON_X + '</button>';
          });
          if (chips.length) h += '<button type="button" class="fntc-chips__clear" data-clear>Limpiar todo</button>';
          else h = '<span class="fntc-chips__none">Sin filtros aplicados</span>';
          chipBox.innerHTML = h;
          chipBox.classList.toggle('has-chips', chips.length > 0);
        }
        var badge = this.querySelector('[data-applied-count]');
        if (badge) { badge.textContent = chips.length; badge.hidden = chips.length === 0; }

        // Contadores
        var word = total === 1 ? ' producto' : ' productos';
        [['[data-count]', total], ['[data-count-top]', total], ['[data-count-sheet]', total], ['[data-shown]', shown], ['[data-total]', total]].forEach(function (p) {
          self.querySelectorAll(p[0]).forEach(function (el) { el.textContent = p[1]; });
        });
        this.querySelectorAll('.fntc-bar__count, .fntc-head__count').forEach(function (el) {
          if (el.lastChild && el.lastChild.nodeType === 3) el.lastChild.textContent = word;
        });
        var sheetBtn = this.querySelector('[data-count-sheet]');
        if (sheetBtn && sheetBtn.nextSibling && sheetBtn.nextSibling.nodeType === 3) sheetBtn.nextSibling.textContent = word;

        var empty = this.querySelector('[data-empty]');
        if (empty) empty.hidden = total > 0;
        this.grid.hidden = total === 0;
        var more = this.querySelector('[data-more]');
        if (more) more.hidden = total === 0;
        var bar = this.querySelector('[data-bar]');
        if (bar) bar.style.width = (total ? Math.round(shown / total * 100) : 0) + '%';
        var lm = this.querySelector('[data-load-more]');
        if (lm) lm.hidden = shown >= total;

        // Preferencia para "Elegir opciones" (un solo valor elegido por grupo)
        var pref = {};
        Object.keys(s.sel).forEach(function (g) {
          if (s.sel[g].length !== 1) return;
          self.items.forEach(function (it) {
            if (!it.groups[g]) return;
            it.groups[g].names.forEach(function (n) { pref[n] = s.sel[g][0]; });
          });
        });
        this.dataset.fntPref = JSON.stringify(pref);

        this.placePromo();
      }

      // La promo cierra la última fila; si la fila está completa ocupa todo el ancho
      placePromo() {
        var promo = this.promo;
        if (!promo) return;
        if (!this.lastShown || !this.shownCount) { promo.hidden = true; return; }
        this.grid.insertBefore(promo, this.lastShown.nextSibling);
        promo.hidden = false;
        var cols = getComputedStyle(this.grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
        var rem = this.shownCount % cols;
        var span = rem === 0 ? cols : cols - rem;
        promo.style.gridColumn = 'span ' + span;
        promo.classList.toggle('is-wide', span > 1);
      }
    }

    customElements.define('fnt-collection-view', FntCollectionView);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-contact-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.fntkReady) return;
      root.dataset.fntkReady = '1';

      // Número de pedido solo con "Mi pedido"
      var inputs = root.querySelectorAll('[data-motivo-input]');
      var orderField = root.querySelector('[data-order-field]');
      function syncOrder() {
        if (!orderField) return;
        var checked = root.querySelector('[data-motivo-input]:checked');
        var show = checked && /pedido/i.test(checked.value);
        orderField.hidden = !show;
      }
      inputs.forEach(function (i) { i.addEventListener('change', syncOrder); });
      syncOrder();

      // Tarjetas que preseleccionan un motivo del formulario
      root.querySelectorAll('[data-set-motivo]').forEach(function (a) {
        a.addEventListener('click', function () {
          var want = (a.dataset.setMotivo || '').toLowerCase();
          inputs.forEach(function (i) {
            if (i.value.toLowerCase() === want) { i.checked = true; }
          });
          syncOrder();
        });
      });

      // Copiar correo
      root.querySelectorAll('[data-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var txt = btn.dataset.copy;
          var done = function () {
            var old = btn.textContent;
            btn.textContent = 'Copiado';
            setTimeout(function () { btn.textContent = old; }, 1600);
          };
          if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, done);
          else done();
        });
      });

      // Puntos del carrusel en celular
      var track = root.querySelector('[data-help-track]');
      var dots = root.querySelectorAll('[data-help-dots] .fntk-help__dot');
      if (track && dots.length) {
        track.addEventListener('scroll', function () {
          var card = track.firstElementChild;
          if (!card) return;
          var step = card.getBoundingClientRect().width + 12;
          var idx = Math.min(dots.length - 1, Math.round(track.scrollLeft / step));
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
        }, { passive: true });
      }
    }
    document.querySelectorAll('.fntk').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('.fntk'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-por-que"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-por-que')) return;

    class FntPorQue extends HTMLElement {
      connectedCallback() {
        // Línea del tiempo: se llena una vez al llegar a la sección
        var tl = this.querySelector('[data-tl]');
        if (tl && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) { tl.classList.add('is-on'); io.disconnect(); }
            });
          }, { threshold: 0.3 });
          io.observe(tl);
        } else if (tl) {
          tl.classList.add('is-on');
        }

        // Celular: la barra de abajo sigue lo que se ha deslizado (de 30% a 100%)
        var sc = this.querySelector('[data-tl-scroll]');
        var bar = this.querySelector('[data-tl-prog]');
        if (sc && bar) {
          var paint = function () {
            var max = sc.scrollWidth - sc.clientWidth;
            var t = max > 0 ? sc.scrollLeft / max : 1;
            bar.style.transform = 'scaleX(' + (0.3 + 0.7 * t) + ')';
          };
          sc.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
          paint();
        }

        // Sellos: al pasar el mouse o tocar, abajo sale qué certifica
        var seals = Array.prototype.slice.call(this.querySelectorAll('[data-seal]'));
        var name = this.querySelector('[data-why-name]');
        var text = this.querySelector('[data-why-text]');
        var pick = function (s) {
          seals.forEach(function (x) {
            var on = x === s;
            x.classList.toggle('is-on', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (name) name.textContent = s.dataset.name;
          if (text) text.textContent = s.dataset.why;
        };
        seals.forEach(function (s) {
          s.addEventListener('mouseenter', function () { pick(s); });
          s.addEventListener('focus', function () { pick(s); });
          s.addEventListener('click', function () { pick(s); });
        });
      }
    }

    customElements.define('fnt-por-que', FntPorQue);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-recomendaciones"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-recommendations')) return;

    class FntRecommendations extends HTMLElement {
      connectedCallback() {
        this.inner = this.querySelector('[data-recs-inner]');
        if (this.inner.children.length) {
          this.initCarousel();
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        this.destroyCarousel();
      }

      async load() {
        try {
          const res = await fetch(this.dataset.url);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-recs-inner]');
          if (fresh && fresh.innerHTML.trim()) {
            this.inner.innerHTML = fresh.innerHTML;
            this.initCarousel();
          } else {
            this.hidden = true;
          }
        } catch (e) {
          this.hidden = true;
        }
      }

      initCarousel() {
        const el = this.inner.querySelector('[data-recs-swiper]');
        if (!el) return;
        if (typeof Swiper === 'undefined') {
          this.swiperWait = setTimeout(() => this.initCarousel(), 100);
          return;
        }
        this.destroyCarousel();

        const cols = Number(this.dataset.cols) || 4;
        const colsMobile = Number(this.dataset.colsMobile) || 1.6;

        this.swiper = new Swiper(el, {
          slidesPerView: colsMobile,
          spaceBetween: 12,
          watchOverflow: true,
          // No arrastrar mientras se eligen opciones dentro de la tarjeta
          noSwipingSelector: '.fnt-pc__panel, button',
          navigation: {
            prevEl: this.inner.querySelector('[data-recs-prev]'),
            nextEl: this.inner.querySelector('[data-recs-next]'),
            disabledClass: 'is-disabled',
            lockClass: 'is-locked'
          },
          pagination: {
            el: this.inner.querySelector('[data-recs-dots]'),
            clickable: true,
            bulletElement: 'button',
            bulletClass: 'fnt-dot',
            bulletActiveClass: 'is-active',
            lockClass: 'is-locked'
          },
          breakpoints: {
            750: { slidesPerView: Math.min(3, cols), spaceBetween: 16 },
            990: { slidesPerView: cols, spaceBetween: 16 }
          }
        });
      }

      destroyCarousel() {
        clearTimeout(this.swiperWait);
        if (this.swiper) {
          try { this.swiper.destroy(true, true); } catch (e) {}
          this.swiper = null;
        }
      }
    }

    customElements.define('fnt-recommendations', FntRecommendations);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fnt-search"]) return;
  try {
    
  (function () {
    if (customElements.get('fnt-search-view')) return;

    var SORT_LABELS = {
      best: 'Relevancia',
      asc: 'Precio: menor a mayor',
      desc: 'Precio: mayor a menor',
      az: 'Nombre: A–Z'
    };

    class FntSearchView extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;
        this.pageSize = Number(this.dataset.pageSize) || 12;
        this.items = Array.from(this.grid.querySelectorAll('.fntc-item')).map(function (el) {
          return {
            el: el,
            price: Number(el.dataset.price) || 0,
            title: String(el.dataset.title || '').toLowerCase(),
            rank: Number(el.dataset.rank) || 0
          };
        });
        this.state = { sort: 'best', limit: this.pageSize };
        this.bind();
        this.apply();
      }

      bind() {
        var self = this;
        this.addEventListener('click', function (e) {
          var t = e.target;
          var s = t.closest('[data-sort]');
          if (s) {
            self.state.sort = s.dataset.sort;
            self.toggleSortMenu(false);
            self.state.limit = self.pageSize;
            return self.apply();
          }
          if (t.closest('[data-sort-toggle]')) {
            var menu = self.querySelector('[data-sort-menu]');
            return self.toggleSortMenu(menu.hidden);
          }
          if (t.closest('[data-load-more]')) {
            self.state.limit += self.pageSize;
            return self.apply();
          }
        });
        document.addEventListener('click', function (e) {
          if (!self.contains(e.target) || !e.target.closest('.fntc-sort')) self.toggleSortMenu(false);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') self.toggleSortMenu(false);
        });
      }

      toggleSortMenu(open) {
        var menu = this.querySelector('[data-sort-menu]');
        var btn = this.querySelector('[data-sort-toggle]');
        if (!menu || !btn) return;
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      apply() {
        var self = this;
        var s = this.state;
        var sorted = this.items.slice();
        if (s.sort === 'asc') sorted.sort(function (a, b) { return a.price - b.price || a.rank - b.rank; });
        else if (s.sort === 'desc') sorted.sort(function (a, b) { return b.price - a.price || a.rank - b.rank; });
        else if (s.sort === 'az') sorted.sort(function (a, b) { return a.title.localeCompare(b.title, 'es'); });
        else sorted.sort(function (a, b) { return a.rank - b.rank; });

        var frag = document.createDocumentFragment();
        sorted.forEach(function (it) { frag.appendChild(it.el); });
        this.grid.appendChild(frag);

        var total = sorted.length;
        var shown = Math.min(total, s.limit);
        sorted.forEach(function (it, i) { it.el.hidden = i >= shown; });

        this.querySelectorAll('[data-sort-label], [data-sort-label-m]').forEach(function (el) {
          el.textContent = SORT_LABELS[s.sort];
        });
        this.querySelectorAll('[data-sort]').forEach(function (b) {
          b.classList.toggle('is-on', b.dataset.sort === s.sort);
        });

        [['[data-count]', total], ['[data-count-top]', total], ['[data-shown]', shown], ['[data-total]', total]].forEach(function (p) {
          self.querySelectorAll(p[0]).forEach(function (el) { el.textContent = p[1]; });
        });

        this.grid.hidden = total === 0;
        var more = this.querySelector('[data-more]');
        if (more) more.hidden = total === 0;
        var bar = this.querySelector('[data-bar]');
        if (bar) bar.style.width = (total ? Math.round(shown / total * 100) : 0) + '%';
        var lm = this.querySelector('[data-load-more]');
        if (lm) lm.hidden = shown >= total;
        var sortBox = this.querySelector('.fntc-sort');
        if (sortBox) sortBox.hidden = total < 2;
      }
    }

    customElements.define('fnt-search-view', FntSearchView);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-hero')) return;

    class FntHero extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        clearTimeout(this.wait);
        if (this.swiper) {
          try { this.swiper.destroy(true, true); } catch (e) {}
          this.swiper = null;
        }
      }

      init() {
        if (typeof Swiper === 'undefined') {
          this.wait = setTimeout(() => this.init(), 100);
          return;
        }
        const el = this.querySelector('[data-hero-swiper]');
        const slides = this.querySelectorAll('.fnt-hero__slide').length;
        if (!el || slides < 2) return;
        const seconds = Number(this.dataset.autoplay) || 0;

        this.swiper = new Swiper(el, {
          loop: true,
          speed: 600,
          autoplay: seconds > 0 ? { delay: seconds * 1000, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
          navigation: {
            prevEl: this.querySelector('[data-hero-prev]'),
            nextEl: this.querySelector('[data-hero-next]')
          },
          pagination: {
            el: this.querySelector('[data-hero-dots]'),
            clickable: true,
            bulletElement: 'button',
            bulletClass: 'fnt-dot',
            bulletActiveClass: 'is-active'
          }
        });
      }
    }

    customElements.define('fnt-hero', FntHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stp-grid-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-cat-carousel')) return;

    class FntCatCarousel extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        clearTimeout(this.wait);
        if (this.swiper) {
          try { this.swiper.destroy(true, true); } catch (e) {}
          this.swiper = null;
        }
      }

      init() {
        if (typeof Swiper === 'undefined') {
          this.wait = setTimeout(() => this.init(), 100);
          return;
        }
        const cols = Math.max(2, Math.min(5, Number(this.dataset.cols) || 4));
        this.swiper = new Swiper(this.querySelector('[data-swiper]'), {
          slidesPerView: 'auto',
          spaceBetween: 10,
          watchOverflow: true,
          navigation: {
            prevEl: this.querySelector('[data-prev]'),
            nextEl: this.querySelector('[data-next]'),
            disabledClass: 'is-disabled',
            lockClass: 'is-locked'
          },
          pagination: {
            el: this.querySelector('[data-dots]'),
            clickable: true,
            bulletElement: 'button',
            bulletClass: 'fnt-dot',
            bulletActiveClass: 'is-active',
            lockClass: 'is-locked'
          },
          breakpoints: {
            750: { slidesPerView: Math.min(2, cols), spaceBetween: 16 },
            990: { slidesPerView: cols, spaceBetween: 16 }
          }
        });
      }
    }

    customElements.define('fnt-cat-carousel', FntCatCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fnt-tabs-carousel')) return;

    class FntTabsCarousel extends HTMLElement {
      connectedCallback() {
        this.swipers = {};
        this.addEventListener('click', (e) => {
          const pill = e.target.closest('[data-tab]');
          if (pill) this.show(pill);
        });
        // Se adelanta la descarga en cuanto hay intención (mouse encima, dedo encima o foco)
        const warm = (e) => {
          const pill = e.target.closest && e.target.closest('[data-tab]');
          if (pill) this.load(pill.dataset.tab).catch(() => {});
        };
        this.addEventListener('pointerover', warm);
        this.addEventListener('focusin', warm);
        this.addEventListener('touchstart', warm, { passive: true });
        this.initPanel(this.querySelector('[data-panel]:not([hidden])'));
      }

      disconnectedCallback() {
        clearTimeout(this.wait);
        Object.values(this.swipers).forEach((s) => { try { s.destroy(true, true); } catch (e) {} });
        this.swipers = {};
      }

      load(index) {
        const panel = this.querySelector('[data-panel="' + index + '"]');
        const list = panel && panel.querySelector('[data-lazy]');
        if (!list) return Promise.resolve();
        if (!list._fntLoad) {
          const max = Number(this.dataset.max) || 8;
          list._fntLoad = fetch(list.dataset.lazy, { credentials: 'same-origin' })
            .then((r) => {
              if (!r.ok) throw new Error('fnt-tabs ' + r.status);
              return r.text();
            })
            .then((html) => {
              const tpl = document.createElement('template');
              tpl.innerHTML = html;
              const items = Array.from(tpl.content.querySelectorAll('.fnt-tabs__slide')).slice(0, max);
              list.replaceChildren(...items);
              list.removeAttribute('data-lazy');
            })
            .catch((err) => {
              list._fntLoad = null;
              throw err;
            });
        }
        return list._fntLoad;
      }

      show(pill) {
        const index = pill.dataset.tab;
        const current = this.querySelector('[data-panel]:not([hidden])');
        const keepHeight = current ? current.offsetHeight : 0;
        this.querySelectorAll('[data-tab]').forEach((b) => {
          const on = b === pill;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== index; });
        if (pill.dataset.url) {
          this.querySelectorAll('[data-tabs-all]').forEach((a) => { a.href = pill.dataset.url; });
        }
        const panel = this.querySelector('[data-panel="' + index + '"]');
        if (panel && panel.querySelector('[data-lazy]')) {
          // Mientras llegan las tarjetas, el panel guarda la altura del anterior (sin saltos)
          panel.style.minHeight = keepHeight + 'px';
          panel.setAttribute('aria-busy', 'true');
          this.load(index)
            .then(() => {
              panel.style.minHeight = '';
              panel.removeAttribute('aria-busy');
              if (!panel.hidden) this.initPanel(panel);
            })
            .catch(() => {
              if (pill.dataset.url) window.location.href = pill.dataset.url;
            });
          return;
        }
        this.initPanel(panel);
      }

      initPanel(panel) {
        if (!panel) return;
        const key = panel.dataset.panel;
        if (this.swipers[key]) { this.swipers[key].update(); return; }
        if (typeof Swiper === 'undefined') {
          this.wait = setTimeout(() => this.initPanel(panel), 100);
          return;
        }
        const cols = Number(this.dataset.cols) || 4;
        this.swipers[key] = new Swiper(panel.querySelector('[data-swiper]'), {
          slidesPerView: 1.6,
          spaceBetween: 12,
          watchOverflow: true,
          noSwipingSelector: '.fnt-pc__panel, button',
          navigation: {
            prevEl: panel.querySelector('[data-prev]'),
            nextEl: panel.querySelector('[data-next]'),
            disabledClass: 'is-disabled',
            lockClass: 'is-locked'
          },
          pagination: {
            el: panel.querySelector('[data-dots]'),
            clickable: true,
            bulletElement: 'button',
            bulletClass: 'fnt-dot',
            bulletActiveClass: 'is-active',
            lockClass: 'is-locked'
          },
          breakpoints: {
            750: { slidesPerView: Math.min(3, cols), spaceBetween: 16 },
            990: { slidesPerView: cols, spaceBetween: 16 }
          }
        });
      }
    }

    customElements.define('fnt-tabs-carousel', FntTabsCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
